"use client"

import { format } from "date-fns"
import { Calendar as CalendarIcon } from "lucide-react"
import * as React from "react"
import { Button } from "@/components/ui/button"
import {
	Popover,
	PopoverContent,
	PopoverTrigger,
} from "@/components/ui/popover"
import { cn } from "@/utils/styles.helpers"
import { Calendar } from "./calendar"

export interface DatePickerProps {
	value?: Date
	onChange?: (date: Date | undefined) => void
	placeholder?: string
	disabled?: boolean
	className?: string
	id?: string
}

export function DatePicker({
	value,
	onChange,
	placeholder = "Select date",
	disabled = false,
	className,
	id,
}: DatePickerProps) {
	const [open, setOpen] = React.useState(false)

	const handleSelect = (date: Date | undefined) => {
		onChange?.(date)
		setOpen(false)
	}

	return (
		<Popover open={open} onOpenChange={setOpen}>
			<PopoverTrigger asChild>
				<Button
					id={id}
					variant="outline"
					disabled={disabled}
					data-empty={!value}
					className={cn(
						"w-full justify-start text-left font-normal data-[empty=true]:text-muted-foreground",
						className,
					)}
				>
					<CalendarIcon className="mr-2 h-4 w-4" />
					{value ? format(value, "yyyy-MM-dd") : <span>{placeholder}</span>}
				</Button>
			</PopoverTrigger>
			<PopoverContent className="w-auto p-0" align="start">
				<Calendar
					mode="single"
					selected={value}
					onSelect={handleSelect}
					captionLayout="dropdown"
				/>
			</PopoverContent>
		</Popover>
	)
}
